// /admin/eval/$id — real route. Mirrors apps/web's app/admin/eval/[id]/page.tsx:
// 'use client' page that reads its own `id` via next/navigation's
// useParams() (shimmed onto TanStack params in next-compat/navigation.tsx),
// so it's lazy-imported directly per the porting convention
// (route-helpers.tsx) — same pattern as routes/admin-chat-detail.tsx.
// Renders one read-only GenUIChat per model tab for a past eval run (GET
// /api/admin/eval/:id, already ported). Registered from routes/admin.tsx
// under the `_admin` guard (routes/guards.tsx).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminEvalDetailPage = lazy(() => import('@/app/admin/eval/[id]/page'));

export const adminEvalDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/eval/$id',
  component: AdminEvalDetailPage,
});
